export class TNCApprovals {
  CourseId: number;
  ApprovedBy: number;
  IsApproved: boolean;
  ApprovalsRemark: string;
  ExpiryDate: Date;
}
